import { Component, forwardRef, ChangeDetectionStrategy, Optional, Inject, Input, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbpBaseConstant } from '@colibrium/abp-base';
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function AbpFieldDisplayLabelComponent_ng_container_0_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r1.reqTextCss);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r1.labelConfig.requiredText, " ");
} }
function AbpFieldDisplayLabelComponent_ng_container_0_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "label", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r2.controlLabelCss);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "lbl_abp_label_", ctx_r2.field.fieldCode, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r2.field.displayLabelText, " ");
} }
function AbpFieldDisplayLabelComponent_ng_container_0_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r3.optionalTextCss);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r3.labelConfig.optionalText, " ");
} }
function AbpFieldDisplayLabelComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, AbpFieldDisplayLabelComponent_ng_container_0_span_1_Template, 2, 3, "span", 1);
    ɵngcc0.ɵɵtemplate(2, AbpFieldDisplayLabelComponent_ng_container_0_label_2_Template, 2, 4, "label", 2);
    ɵngcc0.ɵɵtemplate(3, AbpFieldDisplayLabelComponent_ng_container_0_span_3_Template, 2, 3, "span", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showRequiredText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.field.displayLabelText);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showOptionalText);
} }
function AbpLabelComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelement(2, "abp-field-display-label", 2);
    ɵngcc0.ɵɵelementStart(3, "label", 3);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "div_abp_textbox_", ctx_r0.id, "_", ctx_r0.field.fieldCode, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.field);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate1("id", "lbl_abp_label_value", ctx_r0.field.fieldValue, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ctx_r0.field.fieldValue, " ");
} }
const _c0 = ".abp-input-control[_ngcontent-%COMP%]{display:block;width:100%;height:calc(1.5em + .75rem + 2px);font-size:1rem;font-weight:400;line-height:1.5;border-radius:.25rem;color:#495057;background-color:#fff;padding:.375rem .75rem;margin:0 0 2%;border:1px solid #ced4da}.abp-input-control[_ngcontent-%COMP%]:disabled{background-color:#e9ecef;opacity:1}.error[_ngcontent-%COMP%]{background-color:none;border-left-style:solid!important;border-left-color:#dc3545!important;border-left-width:thick!important}.valid[_ngcontent-%COMP%]{background-color:none;border-left-style:solid!important;border-left-color:#28a745!important;border-left-width:thick!important}.validation-msg[_ngcontent-%COMP%]{color:#dc3545!important}.abp-icon-input[_ngcontent-%COMP%]{display:flex}.abp-icon-input[_ngcontent-%COMP%]   .icon[_ngcontent-%COMP%]{margin-left:-38px;cursor:pointer;display:inline-flex;padding-top:.75rem}.abp-icon-input[_ngcontent-%COMP%]   .icon-input[_ngcontent-%COMP%]{display:inline-flex;width:98%!important}.abp-label-control-value[_ngcontent-%COMP%]{padding:6px 12px;width:100%;margin:0 0 8.75px}.bold-label[_ngcontent-%COMP%]{font-weight:500}";
export { AbpLabelFieldModel } from '@colibrium/abp-form-control-base';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpLabelConstant extends AbpBaseConstant {
}
AbpLabelConstant.labelConfigInjectKey = 'label-config';
AbpLabelConstant.asterikSymbol = '*';
AbpLabelConstant.abp_bold_control_label = 'bold-label';
if (false) {
    /** @type {?} */
    AbpLabelConstant.labelConfigInjectKey;
    /** @type {?} */
    AbpLabelConstant.asterikSymbol;
    /** @type {?} */
    AbpLabelConstant.abp_bold_control_label;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpFieldDisplayLabelComponent {
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} config
     */
    constructor(config) {
        this.config = config;
        this.showRequiredText = false;
        this.showOptionalText = false;
        this.labelConfig = this.getConfigDefaults(config);
        this.setDefaultsForCSS();
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
        this.toggleRequiredOptionalDisplay();
        this.setLabelControlCss();
    }
    /**
     * @param {?} simpleChanges
     * @return {?}
     */
    ngOnChanges(simpleChanges) {
        if (simpleChanges.field && simpleChanges.field.previousValue != simpleChanges.field.currentValue) {
            this.toggleRequiredOptionalDisplay();
            this.setLabelControlCss();
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
    }
    /**
     * @return {?}
     */
    ngAfterViewChecked() {
    }
    //#endregion component events
    //#region service calls
    //#endregion service calls
    //#region public functions/events assoaciated with UI elements
    //#endregion public functions/events assoaciated with UI elements
    //#region private functions
    /**
     * gets default values for configs
     * @private
     * @param {?} injectionModel
     * @return {?}
     */
    getConfigDefaults(injectionModel) {
        if (injectionModel) {
            return injectionModel;
        }
        /** @type {?} */
        let configData = {
            markRequired: true,
            requiredText: AbpLabelConstant.asterikSymbol,
            requiredtextClass: AbpLabelConstant.cssClass.abp_error_text
        };
        return configData;
    }
    /**
     * set required text css class
     * @private
     * @return {?}
     */
    setDefaultsForCSS() {
        if (this.labelConfig.markRequired != undefined && this.labelConfig != null) {
            this.showRequiredText = this.labelConfig.markRequired;
            this.showOptionalText = !this.labelConfig.markRequired;
        }
        this.reqTextCss = (this.labelConfig && this.labelConfig.requiredtextClass) ?
            this.labelConfig.requiredtextClass :
            AbpLabelConstant.cssClass.abp_error_text;
        this.optionalTextCss = (this.labelConfig && this.labelConfig.optionalTextClass) ?
            this.labelConfig.optionalTextClass :
            '';
    }
    /**
     * toggles required and optional text based on field
     * @private
     * @return {?}
     */
    toggleRequiredOptionalDisplay() {
        if (this.field) {
            if (!this.field.isRequired) {
                this.showRequiredText = false;
            }
            else {
                this.showOptionalText = false;
            }
        }
    }
    /**
     * sets label control css value
     * @private
     * @return {?}
     */
    setLabelControlCss() {
        this.controlLabelCss = this.field.displayLabelCss ? this.field.displayLabelCss : AbpLabelConstant.abp_bold_control_label;
    }
}
AbpFieldDisplayLabelComponent.ɵfac = function AbpFieldDisplayLabelComponent_Factory(t) { return new (t || AbpFieldDisplayLabelComponent)(ɵngcc0.ɵɵdirectiveInject(AbpLabelConstant.labelConfigInjectKey, 8)); };
AbpFieldDisplayLabelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpFieldDisplayLabelComponent, selectors: [["abp-field-display-label"]], inputs: { field: "field", id: "id" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(( /**
                 * @return {?}
                 */() => AbpFieldDisplayLabelComponent)),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "class", 4, "ngIf"], [3, "id", "class", 4, "ngIf"], [3, "id"]], template: function AbpFieldDisplayLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpFieldDisplayLabelComponent_ng_container_0_Template, 4, 3, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.field.isVisible));
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc1.AsyncPipe], styles: [_c0], changeDetection: 0 });
/** @nocollapse */
AbpFieldDisplayLabelComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AbpLabelConstant.labelConfigInjectKey,] }] }
];
AbpFieldDisplayLabelComponent.propDecorators = {
    field: [{ type: Input }],
    id: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpFieldDisplayLabelComponent, [{
        type: Component,
        args: [{
                selector: 'abp-field-display-label',
                template: "<ng-container *ngIf=\"field.isVisible|async\">\r\n  <span *ngIf=\"showRequiredText\"\r\n        [class]=\"reqTextCss\">\r\n    {{labelConfig.requiredText}}\r\n  </span>\r\n\r\n  <label id=\"lbl_abp_label_{{field.fieldCode}}\"\r\n         *ngIf=\"field.displayLabelText\"\r\n         [class]=\"controlLabelCss\">\r\n    {{ field.displayLabelText }}\r\n  </label>\r\n\r\n  <span *ngIf=\"showOptionalText\"\r\n        [class]=\"optionalTextCss\">\r\n    {{labelConfig.optionalText}}\r\n  </span>\r\n</ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(( /**
                         * @return {?}
                         */() => AbpFieldDisplayLabelComponent)),
                        multi: true
                    }
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".abp-input-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);font-size:1rem;font-weight:400;line-height:1.5;border-radius:.25rem;color:#495057;background-color:#fff;padding:.375rem .75rem;margin:0 0 2%;border:1px solid #ced4da}.abp-input-control:disabled{background-color:#e9ecef;opacity:1}.error{background-color:none;border-left-style:solid!important;border-left-color:#dc3545!important;border-left-width:thick!important}.valid{background-color:none;border-left-style:solid!important;border-left-color:#28a745!important;border-left-width:thick!important}.validation-msg{color:#dc3545!important}.abp-icon-input{display:flex}.abp-icon-input .icon{margin-left:-38px;cursor:pointer;display:inline-flex;padding-top:.75rem}.abp-icon-input .icon-input{display:inline-flex;width:98%!important}.abp-label-control-value{padding:6px 12px;width:100%;margin:0 0 8.75px}.bold-label{font-weight:500}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AbpLabelConstant.labelConfigInjectKey]
            }] }]; }, { field: [{
            type: Input
        }], id: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AbpFieldDisplayLabelComponent.prototype.field;
    /** @type {?} */
    AbpFieldDisplayLabelComponent.prototype.id;
    /** @type {?} */
    AbpFieldDisplayLabelComponent.prototype.labelConfig;
    /** @type {?} */
    AbpFieldDisplayLabelComponent.prototype.reqTextCss;
    /** @type {?} */
    AbpFieldDisplayLabelComponent.prototype.optionalTextCss;
    /** @type {?} */
    AbpFieldDisplayLabelComponent.prototype.showRequiredText;
    /** @type {?} */
    AbpFieldDisplayLabelComponent.prototype.showOptionalText;
    /** @type {?} */
    AbpFieldDisplayLabelComponent.prototype.controlLabelCss;
    /**
     * @type {?}
     * @private
     */
    AbpFieldDisplayLabelComponent.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion functional/model imports
class AbpLabelComponent {
    //#endregion input properties
    //#region model properties
    //#endregion model properties
    //#region constructor
    /**
     * @param {?} config
     */
    constructor(config) {
        this.config = config;
    }
    //#endregion constructor
    //#region component events
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @param {?} simpleChanges
     * @return {?}
     */
    ngOnChanges(simpleChanges) {
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
    }
    /**
     * @return {?}
     */
    ngAfterViewChecked() {
    }
}
AbpLabelComponent.ɵfac = function AbpLabelComponent_Factory(t) { return new (t || AbpLabelComponent)(ɵngcc0.ɵɵdirectiveInject(AbpLabelConstant.labelConfigInjectKey, 8)); };
AbpLabelComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: AbpLabelComponent, selectors: [["abp-label"]], inputs: { field: "field", id: "id" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef(( /**
                 * @return {?}
                 */() => AbpLabelComponent)),
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 3, consts: [[4, "ngIf"], [3, "id"], [3, "field"], [1, "abp-label-control-value", 3, "id"]], template: function AbpLabelComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AbpLabelComponent_ng_container_0_Template, 5, 5, "ng-container", 0);
        ɵngcc0.ɵɵpipe(1, "async");
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ɵngcc0.ɵɵpipeBind1(1, 1, ctx.field.isVisible));
    } }, directives: [ɵngcc1.NgIf, AbpFieldDisplayLabelComponent], pipes: [ɵngcc1.AsyncPipe], styles: [_c0], changeDetection: 0 });
/** @nocollapse */
AbpLabelComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [AbpLabelConstant.labelConfigInjectKey,] }] }
];
AbpLabelComponent.propDecorators = {
    field: [{ type: Input }],
    id: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpLabelComponent, [{
        type: Component,
        args: [{
                selector: 'abp-label',
                template: "<ng-container *ngIf=\"field.isVisible|async\">\r\n  <div id=\"div_abp_textbox_{{id}}_{{field.fieldCode}}\">\r\n\r\n    <abp-field-display-label [field]=\"field\"></abp-field-display-label>\r\n    <label class=\"abp-label-control-value\" id=\"lbl_abp_label_value{{field.fieldValue}}\">\r\n      {{field.fieldValue}}\r\n    </label>\r\n  </div>\r\n\r\n</ng-container>\r\n",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: forwardRef(( /**
                         * @return {?}
                         */() => AbpLabelComponent)),
                        multi: true
                    }
                ],
                changeDetection: ChangeDetectionStrategy.OnPush,
                styles: [".abp-input-control{display:block;width:100%;height:calc(1.5em + .75rem + 2px);font-size:1rem;font-weight:400;line-height:1.5;border-radius:.25rem;color:#495057;background-color:#fff;padding:.375rem .75rem;margin:0 0 2%;border:1px solid #ced4da}.abp-input-control:disabled{background-color:#e9ecef;opacity:1}.error{background-color:none;border-left-style:solid!important;border-left-color:#dc3545!important;border-left-width:thick!important}.valid{background-color:none;border-left-style:solid!important;border-left-color:#28a745!important;border-left-width:thick!important}.validation-msg{color:#dc3545!important}.abp-icon-input{display:flex}.abp-icon-input .icon{margin-left:-38px;cursor:pointer;display:inline-flex;padding-top:.75rem}.abp-icon-input .icon-input{display:inline-flex;width:98%!important}.abp-label-control-value{padding:6px 12px;width:100%;margin:0 0 8.75px}.bold-label{font-weight:500}"]
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [AbpLabelConstant.labelConfigInjectKey]
            }] }]; }, { field: [{
            type: Input
        }], id: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    AbpLabelComponent.prototype.field;
    /** @type {?} */
    AbpLabelComponent.prototype.id;
    /**
     * @type {?}
     * @private
     */
    AbpLabelComponent.prototype.config;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#region angular imports
//#endregion angular imports
//#region core imports
//#endregion core imports
//#region functional/model imports
//#endregion functional/model imports
/**
 * @record
 */
function AbpLabelConfigModel() { }
if (false) {
    /** @type {?|undefined} */
    AbpLabelConfigModel.prototype.requiredText;
    /** @type {?|undefined} */
    AbpLabelConfigModel.prototype.optionalText;
    /**
     * if true, marks fields with required text. if false, maeks fields with optional text.
     * @type {?|undefined}
     */
    AbpLabelConfigModel.prototype.markRequired;
    /**
     * css for required text
     * @type {?|undefined}
     */
    AbpLabelConfigModel.prototype.requiredtextClass;
    /**
     * css for optional text
     * @type {?|undefined}
     */
    AbpLabelConfigModel.prototype.optionalTextClass;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
//#endregion components
//#region directives
//#endregion directives
//#region pipes/filter
//#endregion pipes/filters
//#region services
//#endregion services
//#region handlers/providers
//#endregion handlers/providers
class AbpLabelModule {
    /**
     * @param {?} config
     * @return {?}
     */
    static forRoot(config) {
        return (/** @type {?} */ ({
            ngModule: AbpLabelModule,
            providers: [
                { provide: AbpLabelConstant.labelConfigInjectKey, useValue: config }
            ]
        }));
    }
}
AbpLabelModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AbpLabelModule });
AbpLabelModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AbpLabelModule_Factory(t) { return new (t || AbpLabelModule)(); }, imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AbpLabelModule, { declarations: function () { return [AbpLabelComponent, AbpFieldDisplayLabelComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [AbpLabelComponent, AbpFieldDisplayLabelComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AbpLabelModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    AbpLabelComponent,
                    AbpFieldDisplayLabelComponent
                ],
                exports: [
                    AbpLabelComponent,
                    AbpFieldDisplayLabelComponent
                ],
                entryComponents: [
                    AbpLabelComponent,
                    AbpFieldDisplayLabelComponent
                ]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { AbpFieldDisplayLabelComponent, AbpLabelComponent, AbpLabelConstant, AbpLabelModule };

//# sourceMappingURL=colibrium-abp-label.js.map